var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "card-item checkin-content" }, [
      !_vm.isLoading
        ? _c(
            "div",
            { staticClass: "progress-bar is-gray" },
            [
              _c(
                "b-progress",
                {
                  attrs: {
                    "show-value": true,
                    size: "is-medium",
                    type: "is-custom",
                    value: _vm.calculateProgress(
                      _vm.activeStep,
                      _vm.totalSteps
                    ),
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.activeStep + 1) +
                      " de " +
                      _vm._s(_vm.totalSteps) +
                      " "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "card-content", attrs: { id: "checkin-welcome" } },
        [
          _c(
            "b-steps",
            {
              attrs: {
                animated: _vm.isAnimated,
                rounded: _vm.isRounded,
                "has-navigation": _vm.hasNavigation,
                "icon-prev": _vm.prevIcon,
                "icon-next": _vm.nextIcon,
                "label-position": _vm.labelPosition,
                "mobile-mode": _vm.mobileMode,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "navigation",
                    fn: function ({ previous, next }) {
                      return _vm.customNavigation
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "button-navigation-checkin columns is-mobile",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "column has-text-left" },
                                  [
                                    _vm.isParking
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !previous.disabled,
                                                expression:
                                                  "!previous.disabled",
                                              },
                                            ],
                                            staticClass: "is-white step",
                                            attrs: {
                                              rounded: "",
                                              "icon-pack": "fas",
                                              "icon-left": "angle-left",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return previous.action.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" Atrás ")]
                                        )
                                      : _vm._e(),
                                    !_vm.isParking
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !previous.disabled,
                                                expression:
                                                  "!previous.disabled",
                                              },
                                            ],
                                            staticClass: "is-white step",
                                            attrs: {
                                              "icon-pack": "fas",
                                              "icon-left": "angle-left",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return previous.action.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" Atrás ")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                !_vm.isLoading
                                  ? _c(
                                      "div",
                                      { staticClass: "column has-text-right" },
                                      [
                                        _vm.isParking
                                          ? _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: !next.disabled,
                                                    expression:
                                                      "!next.disabled",
                                                  },
                                                ],
                                                staticClass: "is-white step",
                                                attrs: {
                                                  rounded: "",
                                                  "icon-pack": "fas",
                                                  "icon-right": "angle-right",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return next.action.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" Siguiente ")]
                                            )
                                          : _vm._e(),
                                        !_vm.isParking
                                          ? _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: !next.disabled,
                                                    expression:
                                                      "!next.disabled",
                                                  },
                                                ],
                                                staticClass: "is-white step",
                                                attrs: {
                                                  "icon-pack": "fas",
                                                  "icon-right": "angle-right",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return next.action.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" Siguiente ")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        : undefined
                    },
                  },
                ],
                null,
                true
              ),
              model: {
                value: _vm.activeStep,
                callback: function ($$v) {
                  _vm.activeStep = $$v
                },
                expression: "activeStep",
              },
            },
            [
              _c(
                "b-step-item",
                { attrs: { clickable: _vm.isStepsClickable } },
                [
                  _c("Spinner", { attrs: { "is-loading": _vm.isLoading } }),
                  !_vm.isLoading
                    ? _c(
                        "div",
                        { staticClass: "columns is-desktop is-vcentered" },
                        [
                          _c(
                            "div",
                            { staticClass: "image-check-in column py-0" },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/ui/assets/img/questions1.svg"),
                                  alt: "seguridad",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-content column is-three-quarters-desktop",
                            },
                            [
                              _c("h3", { staticClass: "is-size-5" }, [
                                _vm._v("Bienvenidos a Creditú"),
                              ]),
                              _c("p", { staticClass: "is-size-6" }, [
                                _vm._v(
                                  " En nuestro sitio web y en tu portal privado podrás: "
                                ),
                              ]),
                              _c(
                                "ul",
                                {
                                  staticClass: "is-size-6",
                                  staticStyle: {
                                    "list-style-type": "disc",
                                    "padding-left": "1.5em",
                                  },
                                },
                                [
                                  _c("li", [
                                    _vm._v(" Utilizar "),
                                    _c("strong", [
                                      _vm._v("nuestra plataforma de pago"),
                                    ]),
                                    _vm._v(
                                      ", apenas tu cuota esté disponible. "
                                    ),
                                  ]),
                                  _c("li", [
                                    _vm._v("Recibir "),
                                    _c("strong", [
                                      _vm._v("nuestros servicios de atención"),
                                    ]),
                                    _vm._v(" al cliente."),
                                  ]),
                                  _vm.hasDigitalSignatureLink
                                    ? _c("li", [
                                        _vm._v(
                                          " Ver documentos relacionados a tus créditos. "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass: "is-size-6",
                                  staticStyle: { "margin-top": "1em" },
                                },
                                [_vm._v("✨ Todo en un mismo lugar.")]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "b-step-item",
                { attrs: { clickable: _vm.isStepsClickable, disabled: "" } },
                [
                  _c("Spinner", { attrs: { "is-loading": _vm.isLoading } }),
                  !_vm.isLoading
                    ? _c(
                        "div",
                        { staticClass: "columns is-vcentered is-desktop" },
                        [
                          _c(
                            "div",
                            { staticClass: "image-check-in column py-0" },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/ui/assets/img/question4.svg"),
                                  alt: "seguridad",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-content column is-three-quarters-desktop",
                            },
                            [
                              _c("h3", { staticClass: "is-size-5" }, [
                                _vm._v(
                                  "¿Cuáles medios de pago tendré disponible en Creditú?"
                                ),
                              ]),
                              _c("p", { staticClass: "is-size-6" }, [
                                _vm._v(
                                  " Podrás pagar tu dividendo dentro de tu sitio privado 100% online con los siguientes medios de pago: "
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "columns is-centered" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "column is-one-quarter-desktop",
                                      attrs: { id: "payment-method" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "payment-icon" },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-university",
                                          }),
                                        ]
                                      ),
                                      _c("p", [
                                        _c(
                                          "span",
                                          { staticClass: "payment-label" },
                                          [_vm._v("Transferencia bancaria")]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "column is-one-quarter-desktop",
                                      attrs: { id: "payment-method" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "payment-icon" },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-credit-card",
                                          }),
                                        ]
                                      ),
                                      _c("p", [
                                        _c(
                                          "span",
                                          { staticClass: "payment-label" },
                                          [_vm._v("Servipag")]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "column is-one-quarter-desktop",
                                      attrs: { id: "payment-method" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "payment-icon" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-money-bill-wave",
                                          }),
                                        ]
                                      ),
                                      _c("p", [
                                        _c(
                                          "span",
                                          { staticClass: "payment-label" },
                                          [_vm._v("Depósito en efectivo")]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "column is-one-quarter-desktop",
                                      attrs: { id: "payment-method" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "payment-icon" },
                                        [
                                          _c("img", {
                                            staticClass: "img-gray",
                                            attrs: {
                                              alt: "neat logo",
                                              src: require("@/ui/assets/img/neat.svg"),
                                            },
                                          }),
                                        ]
                                      ),
                                      _c("p", [
                                        _c(
                                          "span",
                                          { staticClass: "payment-label" },
                                          [_vm._v("Neat Pagos")]
                                        ),
                                      ]),
                                      _c("p", [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pay-method-sub font-size",
                                          },
                                          [_vm._v("(Tarjeta de crédito)")]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.isParking
                ? _c(
                    "b-step-item",
                    {
                      attrs: { clickable: _vm.isStepsClickable, disabled: "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "columns is-vcentered is-desktop" },
                        [
                          _c(
                            "div",
                            { staticClass: "image-check-in column py-0" },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/ui/assets/img/question4.svg"),
                                  alt: "seguridad",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-content column is-three-quarters-desktop",
                            },
                            [
                              _c("h3", { staticClass: "is-size-5" }, [
                                _vm._v(
                                  " Aquí te dejamos un resumen de los créditos nuevos que tienes con nosotros. "
                                ),
                              ]),
                              _c("p", { staticClass: "is-size-6" }, [
                                _vm._v(
                                  " Por favor revisa si la información es correcta antes de continuar. "
                                ),
                              ]),
                              _c("p", { staticClass: "is-size-6" }, [
                                _vm._v(
                                  ' Si tienes dudas, puedes hacer click en "Quiero que me contacten" para contactarte con nosotros antes de continuar. '
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _vm._l(_vm.clientDataResume, function (operation, i) {
                        return _c(
                          "div",
                          {
                            key: `operation${i}`,
                            staticClass:
                              "operation-details is-flex is-flex-direction-column",
                          },
                          [
                            operation.creditType === "PARKING"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "card-item mb-4 py-2 is-flex is-flex-wrap-wrap is-justify-content-space-between is-align-items-center",
                                  },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "h3",
                                          {
                                            staticClass:
                                              "is-size-6 has-text-grey-dark",
                                            attrs: {
                                              icon: _vm.iconType[
                                                operation.creditType
                                              ],
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    operation.creditType?.toLowerCase()
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "b-tag",
                                          {
                                            staticClass: "m-1",
                                            attrs: {
                                              icon: "hashtag",
                                              type: "is-primary is-light",
                                              rounded: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("creditName") +
                                                    operation.companyOperationId
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "b-tag",
                                          {
                                            staticClass: "m-1",
                                            attrs: {
                                              icon: "dollar-sign",
                                              type: "is-primary is-light",
                                              rounded: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("insolute")) +
                                                " " +
                                                _vm._s(
                                                  operation.creditType ===
                                                    "MORTGAGE" ||
                                                    operation.creditType ===
                                                      "PARKING"
                                                    ? _vm.$t(
                                                        "mortgageMonetaryValue"
                                                      )
                                                    : _vm.$t(
                                                        "complementaryMonetaryValue"
                                                      )
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.formatter.format(
                                                    operation.balanceAmmount.toFixed(
                                                      2
                                                    )
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "b-tag",
                                          {
                                            staticClass: "m-1",
                                            attrs: {
                                              icon: "hashtag",
                                              type: "is-primary is-light",
                                              rounded: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("quotaNumber")) +
                                                " " +
                                                _vm._s(operation.termAsMonths) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "p-3" },
                                      _vm._l(
                                        _vm.debtDataResume,
                                        function (debt, index) {
                                          return _c("div", { key: index }, [
                                            debt.companyOperationId ===
                                            operation.companyOperationId
                                              ? _c("div", [
                                                  _vm._v(
                                                    " Monto de la cuota: "
                                                  ),
                                                  _c(
                                                    "strong",
                                                    {
                                                      staticClass:
                                                        "has-text-primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "UF " +
                                                          _vm._s(
                                                            _vm.formatter.format(
                                                              debt.monthlyPayment.toFixed(
                                                                2
                                                              )
                                                            )
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.isParking && _vm.hasDigitalSignatureLink
                ? _c(
                    "b-step-item",
                    {
                      attrs: { clickable: _vm.isStepsClickable, disabled: "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "columns is-vcentered is-desktop" },
                        [
                          _c(
                            "div",
                            { staticClass: "image-check-in column py-0" },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/ui/assets/img/question4.svg"),
                                  alt: "seguridad",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-content column is-three-quarters-desktop",
                            },
                            [
                              _c("h3", { staticClass: "is-size-5" }, [
                                _vm._v(
                                  " ¿Tienes aún pendiente la documentación de esta nueva administración? "
                                ),
                              ]),
                              _c("p", { staticClass: "is-size-6" }, [
                                _vm._v(
                                  " Accede a tu documentación para firmar con Clave Única en solo unos minutos y 100% online, sin papeles y sin salir de tu casa. "
                                ),
                              ]),
                              _c(
                                "p",
                                { staticClass: "mt-5" },
                                _vm._l(
                                  _vm.debtDataResume,
                                  function (debt, index) {
                                    return _c(
                                      "a",
                                      {
                                        key: index,
                                        staticClass:
                                          "button is-primary is-rounded",
                                        attrs: {
                                          href: debt.digitalSignatureLink,
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "pen" },
                                        }),
                                        _c("span", [
                                          _vm._v("Ir a firmar con Clave única"),
                                        ]),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "confirmed-term" }, [
        _c("div", { staticClass: "button-content transition-slow" }, [
          (_vm.isParking && (_vm.activeStep === 2 || _vm.activeStep === 3)) ||
          (_vm.isParking &&
            !_vm.hasDigitalSignatureLink &&
            _vm.activeStep === 3)
            ? _c(
                "button",
                {
                  staticClass: "button is-rounded mr-2",
                  attrs: { id: "continueButton" },
                  on: {
                    click: () => {
                      _vm.$router.push({ name: "support" })
                    },
                  },
                },
                [_vm._v(" Quiero que me contacten ")]
              )
            : _vm._e(),
          _vm.isParking && _vm.hasDigitalSignatureLink && _vm.activeStep === 3
            ? _c(
                "button",
                {
                  staticClass: "button is-button-primary is-rounded",
                  attrs: { id: "continueButton" },
                  on: {
                    click: () => {
                      _vm.$router.push({ name: "confirmed" })
                    },
                  },
                },
                [_vm._v(" Ya firmé ")]
              )
            : _vm._e(),
          (_vm.isParking &&
            !_vm.hasDigitalSignatureLink &&
            _vm.activeStep === 2) ||
          (!_vm.isParking && _vm.activeStep === 1)
            ? _c(
                "button",
                {
                  staticClass: "button is-button-primary is-rounded",
                  attrs: { id: "continueButton" },
                  on: {
                    click: () => {
                      _vm.$router.push({ name: "confirmed" })
                    },
                  },
                },
                [_vm._v(" Continuar ")]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }